import { Box, Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import { PageShell } from 'components/AppShell';
import { USE_NEW_SHELL } from 'core/flags';
import Generator from './Generator';
import Validate from './Validate';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const active = value === index;

  return (
    <Box
      role="tabpanel"
      hidden={!active}
      sx={{
        flex: active ? 1 : 0,
        minHeight: active ? 0 : undefined,
        overflow: 'hidden',
        display: active ? 'flex' : 'none',
        flexDirection: 'column',
      }}
      {...other}
    >
      {active ? (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            pt: 2,
            overflow: 'hidden',
          }}
        >
          {children}
        </Box>
      ) : null}
    </Box>
  );
}

export default function TechnicalTaskPage() {
  const [value, setValue] = useState(0);

  const body = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
      }}
    >
      {!USE_NEW_SHELL && (
        <Tabs
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{ flexShrink: 0, borderBottom: 1, borderColor: 'divider', mb: 0 }}
        >
          <Tab value={0} label="Генератор ТЗ" />
          <Tab value={1} label="Валидатор ТЗ" />
        </Tabs>
      )}
      <TabPanel value={value} index={0}>
        <Generator />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <Validate />
        </Box>
      </TabPanel>
    </Box>
  );

  if (USE_NEW_SHELL) {
    return (
      <PageShell
        title="ТЗ"
        subtitle="Генерация и валидация технических заданий"
        toolbar={
          <Tabs
            value={value}
            onChange={(_, newValue) => setValue(newValue)}
            sx={{
              minHeight: 36,
              '& .MuiTab-root': { minHeight: 36, py: 0.5, fontSize: 13, textTransform: 'none' },
            }}
          >
            <Tab value={0} label="Генератор" />
            <Tab value={1} label="Валидатор" />
          </Tabs>
        }
        bodyScrolls={false}
        noContentPadding
      >
        {body}
      </PageShell>
    );
  }

  return body;
}
